import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/sportmonks.webp';
import screenshot_target from '../../../images/letterfunnel/ronnievisser.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Ronnie Visser"
      firstname="Ronnie"
      companyname="Sportmonks"
      competition="API-FOOTBALL en Data Sports Group"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ronnievisser.js